import { gql, useMutation } from "@apollo/client";
import { useGeneralSoContext } from "src/common/context";
const FINISH_OFFLINE_PURCHASE_MUTATION = gql(`
  mutation FinishOfflinePurchase($offerId: String!) {
    finishOfflineOffer(id: $offerId)
  }
  `);

export function useFinishOfflinePurchase() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation(FINISH_OFFLINE_PURCHASE_MUTATION);
  const finishOfflinePurchase = async () => {
    if (!offerId) {
      return;
    }
    const { data } = await mutation({
      variables: { offerId },
    });
    return data;
  };
  return [finishOfflinePurchase, info] as const;
}
